import axios from 'axios'
import { Ref, defineComponent, getCurrentInstance, reactive, ref } from 'vue'

import { CsDsaReportLink, CsModal, CsPrimaryButton, CsRadioButton, CsTextarea, MsHeadline } from '@sunrise/components'
import { screenSizeDetection } from '@sunrise/shared'
import { useGlobalStore } from '@sunrise/shared'

import MsFormSuccess from '../../static/illus/formSuccess.svg?component'
import { ComplaintReasons } from './MsDetailModalReport.enum'
import { FormDataReportAbuse } from './MsDetailModalReport.interface'

export default defineComponent({
    name: 'MsDetailModalReport',
    components: {
        CsDsaReportLink,
        CsModal,
        CsPrimaryButton,
        CsRadioButton,
        CsTextarea,
        MsHeadline,
        MsFormSuccess,
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
        exposeeId: {
            type: Number,
            required: true,
        },
    },
    emits: ['closeModal'],
    setup(props, { emit }) {
        const globalStore = useGlobalStore()
        const servicePath = globalStore.urlPaths?.services
        const SERVICE_URL = `${servicePath}/report-abuse`
        const currentInstance = getCurrentInstance()?.proxy
        const { isScreenM } = screenSizeDetection()
        const showErrorMessage = ref<boolean>(false)
        const showSuccessView = ref<boolean>(false)
        const isDisabled = ref<boolean>(false)
        const formElement: Ref<null | HTMLFormElement> = ref(null)
        const errorMsgElement: Ref<null | HTMLElement> = ref(null)
        const successPage: Ref<null | HTMLElement> = ref(null)
        const complaintReasons: ComplaintReasons[] = [
            ComplaintReasons.DUBIOUS,
            ComplaintReasons.FAKE,
            ComplaintReasons.INCORRECT_LOCATION,
            ComplaintReasons.UNAVAILABLE,
            ComplaintReasons.ALIENATED,
        ]
        const formData: FormDataReportAbuse = reactive({
            reason: ComplaintReasons.EMPTY,
            message: '',
        })

        function onSubmit() {
            if (formData.reason === ComplaintReasons.EMPTY) {
                emptyComplaintReasonHandler()
                return
            }

            isDisabled.value = true
            sendFormData(formData)
        }

        function sendFormData(formData: FormDataReportAbuse) {
            axios
                .post(SERVICE_URL, { ...formData, realEstateId: props.exposeeId })
                .then(successHandler)
                .catch(function (error) {
                    console.error(error)
                })
                .finally(() => {
                    isDisabled.value = false
                })
        }

        function emptyComplaintReasonHandler() {
            showErrorMessage.value = true

            currentInstance?.$nextTick(() => {
                formElement.value?.scrollIntoView({ behavior: 'smooth' })
            })
        }

        function successHandler() {
            showSuccessView.value = true
            showErrorMessage.value = false
            resetFormData()
            currentInstance?.$nextTick(() => {
                successPage.value?.scrollIntoView({ behavior: 'smooth' })
            })
        }

        function emitCloseModalEvent() {
            emit('closeModal')
            showSuccessView.value = false
            showErrorMessage.value = false
        }

        function resetFormData() {
            formData.reason = ComplaintReasons.EMPTY
            formData.message = ''
        }

        function updateComplaints() {
            showErrorMessage.value = false
        }

        function getErrorMessage(index: number): string {
            if (showErrorMessage.value && index === complaintReasons.length - 1) {
                return 'Bitte wähle eine der Optionen.'
            } else {
                return ''
            }
        }

        return {
            isScreenM,
            complaintReasons,
            formData,
            showErrorMessage,
            showSuccessView,
            isDisabled,
            formElement,
            errorMsgElement,
            successPage,
            onSubmit,
            emitCloseModalEvent,
            updateComplaints,
            getErrorMessage,
        }
    },
})
